"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCustomErrorWithData = createCustomErrorWithData;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("./constants");
var _internals = require("./internals");
/* eslint-disable @typescript-eslint/no-explicit-any -- needed */ /**
 * Function for creating custom error classes. Such custom error class properly subclasses built-in `Error`, simplifies
 * generating error messages via predefined error codes and allows attaching custom data to the error instance.
 *
 * @param errorName Error name.
 * @param errorMessages Object containing all possible error messages.
 * @param errorData Runtime representation of the `ErrorData` type parameter; can be either a class expression, or a Zod schema.
 * @return Class that implements {@linkcode CustomErrorWithData}.
 */ function createCustomErrorWithData(errorName, errorMessages, errorData) {
    return /*#__PURE__*/ function(Error1) {
        _inherits(InternalCustomError, Error1);
        function InternalCustomError(errorCode, options) {
            _class_call_check(this, InternalCustomError);
            var _this;
            var errorMessage = (0, _internals.createErrorMessage)(errorCode, errorMessages, options === null || options === void 0 ? void 0 : options.messageParameters);
            var errorOptions = {};
            if (typeof (options === null || options === void 0 ? void 0 : options.cause) !== 'undefined') {
                errorOptions.cause = options.cause;
            }
            _this = _call_super(this, InternalCustomError, [
                errorMessage,
                errorOptions
            ]);
            (0, _defineProperty2.default)(_this, "code", void 0);
            (0, _defineProperty2.default)(_this, "data", void 0);
            _this.code = errorCode;
            _this.name = errorName;
            if (typeof (options === null || options === void 0 ? void 0 : options.data) !== 'undefined') {
                _this.data = options.data;
            }
            // if the message is empty, we are making this an unknown error
            if (!_this.message) {
                _this.code = _constants.UNKNOWN_ERROR;
                _this.message = (0, _internals.createErrorMessage)(_constants.UNKNOWN_ERROR, _constants.INTERNAL_ERROR_MESSAGES);
            }
            return _this;
        }
        return InternalCustomError;
    }(_wrap_native_super(Error));
} //# sourceMappingURL=createCustomErrorWithData.js.map
